import { useCurrentCast } from '@/modules/casts/compositions'
import store from '@/store'
import { computed } from '@vue/composition-api'

const toggleSceneAutoSwitch = async (isEnabled: boolean) => {
  const result = await store.dispatch.events.updateCurrentCast((cast) => {
    cast.scenesSettings.toggleAutoSwitch(isEnabled)
    return cast
  })
  result.logIfError('Could not toggle auto switch mode')
}

const toggleSceneAutoCasterBox = async (isEnabled: boolean) => {
  const result = await store.dispatch.events.updateCurrentCast((cast) => {
    cast.scenesSettings.toggleAutoCasterBox(isEnabled)
    return cast
  })
  result.logIfError('Could not toggle auto caster box')
}

const toggleAutoAcceptGuests = async (isEnabled: boolean) => {
  const result = await store.dispatch.events.updateCurrentCast((cast) => {
    cast.scenesSettings.toggleAutoAcceptGuests(isEnabled)
    return cast
  })
  result.logIfError('Could not toggle auto accept guests')
}

const setAutoSwitchSceneId = async (index: number, sceneId: string|null) => {
  const failMsg = `Could not set scene [${ sceneId }] for auto switch index [${ index }].`
  const result = await store.dispatch.events.updateCurrentCast((cast) => {
    const result = cast.scenesSettings.setAutoSwitchSceneId(index, sceneId)
    result.logIfError(failMsg)
    return cast
  })
  result.logIfError(failMsg)
}

const toggleUseBackupStreams = async (isEnabled: boolean) => {
  const result = await store.dispatch.events.updateCurrentCast((cast) => {
    cast.scenesSettings.toggleUseBackupStreams(isEnabled)
    return cast
  })
  result.logIfError('Could not toggle use of backup streams')
}

const useScenesSettings = () => {
  const { currentCast } = useCurrentCast()
  const isSceneAutoSwitchEnabled = computed(() => !!currentCast.value?.scenesSettings.isAutoSwitchEnabled)
  const isSceneAutoCasterBoxEnabled = computed(() => !!currentCast.value?.scenesSettings.isAutoCasterBoxEnabled)
  const isAutoAcceptGuestsEnabled = computed(() => currentCast.value?.scenesSettings.isAutoAcceptGuestsEnabled ?? true)
  const autoSwitchSceneIds = computed(() => currentCast.value?.scenesSettings.autoSwitchSceneIds ?? [])
  const isBackupStreamsEnabled = computed(() => !!currentCast.value?.scenesSettings.isBackupStreamsEnabled)

  return {
    autoSwitchSceneIds,
    isAutoAcceptGuestsEnabled,
    isBackupStreamsEnabled,
    isSceneAutoCasterBoxEnabled,
    isSceneAutoSwitchEnabled,
    setAutoSwitchSceneId,
    toggleAutoAcceptGuests,
    toggleSceneAutoCasterBox,
    toggleSceneAutoSwitch,
    toggleUseBackupStreams
  }
}

export default useScenesSettings
